angular.module('impactx.product').controller('OrderedProductsCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    OrderedProductsCtrl
]);

function OrderedProductsCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    dataGen.getData($scope, {withoutDateRangeFilter: false}, '/product/orderedproducts');
}